const grids = document.querySelectorAll('[data-leaders-grid]');
const RESIZE_DEBOUNCE_MS = 150;

function getColumnCount(grid) {
    return Number(getComputedStyle(grid).getPropertyValue('--cols')) || 1;
}

// Which grid column (1-based) a card currently sits in.
function getColumn(grid, card) {
    const gridLeft = grid.getBoundingClientRect().left;
    const cardRect = card.getBoundingClientRect();
    const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    return Math.round((cardRect.left - gridLeft) / (cardRect.width + gap)) + 1;
}

function setOpen(grid, nextCard) {
    const col = Math.min(getColumn(grid, nextCard), getColumnCount(grid));

    const swap = () => {
        grid.querySelectorAll('[data-leader-card]').forEach((card) => {
            const isOpen = card === nextCard;
            const bio = card.querySelector('.leader-bio');

            card.classList.toggle('is-open', isOpen);
            card.querySelector('[data-leader-toggle]').setAttribute('aria-expanded', String(isOpen));
            if (bio) bio.hidden = !isOpen;

            if (isOpen) {
                card.style.setProperty('--col', String(col));
            } else {
                card.style.removeProperty('--col');
            }
        });
    };

    if (document.startViewTransition) {
        document.startViewTransition(swap);
    } else {
        swap();
    }
}

grids.forEach((grid) => {
    grid.querySelectorAll('[data-leader-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const card = toggle.closest('[data-leader-card]');
            // One card is always open, so clicking the open card does nothing.
            if (card.classList.contains('is-open')) return;
            setOpen(grid, card);
        });
    });
});

// Keep the open card inside the grid when a resize drops a column.
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        grids.forEach((grid) => {
            const openCard = /** @type {HTMLElement} */ (grid.querySelector('.leader-card.is-open'));
            if (!openCard) return;
            const col = Number(openCard.style.getPropertyValue('--col')) || 1;
            const count = getColumnCount(grid);
            if (col > count) openCard.style.setProperty('--col', String(count));
        });
    }, RESIZE_DEBOUNCE_MS);
});
